/**
 * The vertical rhythm of an AI drawer's form — the whole of it, in two numbers.
 *
 * There were seven. Sections were 16px apart in four drawers, 8px in
 * 短片腳本生成器 and 10px in 破冰話術; a label sat 8px above the control it names
 * in some places and 12, 14 or 16 in others, because `FormLabelWithIcon` carried
 * a 12/8 margin of its own AND the control under it added a `marginTop` of 4, 6
 * or 8 on top — while six call sites passed `marginTop: 6, marginBottom: 4` to
 * cancel the label's default and the rest did not. Nothing decided those
 * numbers; each was chosen next to the one thing its author was looking at.
 *
 * The rule now: a CONTAINER owns the space between its sections, and a LABEL
 * owns the space down to the control it names. Nothing owns both, so no gap is
 * ever the sum of two decisions.
 *
 * SECTION_GAP is spelled as MUI `spacing={2}` on the drawers' top-level Grid,
 * which is the same 16px and reads as MUI rather than as a magic number; it is
 * here so the two halves of the rhythm can be read together.
 */
export const LABEL_GAP = 6;
export const SECTION_GAP = 16;

/**
 * What a free-text box looks like in an AI drawer.
 *
 * There were two shells. `FreeTextArea` carried an 8px radius and a 1.4rem
 * face; 短片腳本生成器, 添加 Emojis and 改寫訊息 used a bare MUI `TextField` at
 * default radius and size, and 熱話推薦 hand-copied FreeTextArea's two numbers
 * inline. So the same question — "type something for the AI" — was asked in
 * two visibly different boxes depending on which drawer the adviser opened,
 * and the numbers had already been copied once.
 *
 * Pure styling: no box changes what it holds, validates or submits.
 */
export const textInputSx = {
  borderRadius: '8px',
  fontSize: '1.4rem'
};

/**
 * The same box when it takes more than one line.
 *
 * `alignItems` because a multiline InputBase otherwise centres its text against
 * the grown box, and the cap because a box that grows without one eventually
 * pushes the CTA off a handset. Split from the single-line shape rather than
 * folded into it: `alignItems` on a one-line input is a no-op at best and a
 * quiet shift the day an adornment is added.
 */
export const multilineTextInputSx = {
  ...textInputSx,
  alignItems: 'flex-start',
  '& textarea': {
    maxHeight: '20dvh',
    overflow: 'auto !important'
  }
};
